import { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X, Bell, ChevronDown } from "lucide-react";
import { useAuth } from "../../hooks/useAuth";

export default function Header({ isLoggedIn = false, userName = "" }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const { logout } = useAuth();

  const handleLogout = async () => {
    try {
      setIsLoggingOut(true);
      await logout();
    } catch (error) {
      console.error("Erro ao fazer logout:", error);
    } finally {
      setIsLoggingOut(false);
    }
  };

  return (
    <header className="bg-white shadow-sm border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex items-center justify-between h-24">
          {/* Left Side - Menu + Logo */}
          <div className="flex items-center gap-4">
            <button
              className="p-2 text-gray-600 hover:text-gray-800 lg:hidden"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
              {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>

            <Link to="/home" className="flex items-center">
              <img
                src="/faptec_logo.png"
                alt="FAPITEC|SE"
                className="h-16 w-auto cursor-pointer hover:opacity-80 transition-opacity"
              />
            </Link>
          </div>

          {/* Center Navigation - Desktop */}
          <nav className="hidden lg:flex items-center gap-8">
            <a
              href="#"
              className="text-sm text-gray-600 hover:text-indigo-900 transition-colors"
            >
              Precisa de ajuda?
            </a>
            <a
              href="#"
              className="text-sm text-indigo-900 font-semibold hover:text-indigo-700 transition-colors"
            >
              SUPORTE
            </a>
            <a
              href="#"
              className="text-sm text-indigo-900 font-semibold hover:text-indigo-700 transition-colors"
            >
              FALE CONOSCO
            </a>
          </nav>

          {/* Right Side - User Menu (only if logged in) */}
          {isLoggedIn && (
            <div className="hidden lg:flex items-center gap-4">
              {/* Notification Bell */}
              <button className="relative p-2 text-gray-600 hover:text-gray-800">
                <Bell size={20} />
                <span className="absolute top-1 right-1 w-2 h-2 bg-red-600 rounded-full"></span>
              </button>

              {/* User Dropdown */}
              <div className="relative">
                <button
                  className="flex items-center gap-2 text-sm text-gray-700 hover:text-gray-900"
                  onClick={() => setIsUserMenuOpen(!isUserMenuOpen)}
                >
                  <span>Bem-vindo ao FAPITEC, {userName}</span>
                  <ChevronDown size={16} />
                </button>

                {/* Dropdown Menu */}
                {isUserMenuOpen && (
                  <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg py-1 z-10">
                    <a
                      href="#"
                      className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                    >
                      Meu Perfil
                    </a>
                    <a
                      href="#"
                      className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                    >
                      Configurações
                    </a>
                    <hr className="my-1" />
                    <button
                      onClick={handleLogout}
                      disabled={isLoggingOut}
                      className="w-full text-left block px-4 py-2 text-sm text-red-600 hover:bg-gray-100 disabled:opacity-50"
                    >
                      {isLoggingOut ? "Saindo..." : "Sair"}
                    </button>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav className="lg:hidden py-4 border-t border-gray-200">
            <div className="flex flex-col gap-2">
              <a
                href="#"
                className="text-sm text-gray-600 hover:text-indigo-900 transition-colors py-2"
              >
                Precisa de ajuda?
              </a>
              <a
                href="#"
                className="text-sm text-indigo-900 font-semibold hover:text-indigo-700 transition-colors py-2"
              >
                SUPORTE
              </a>
              <a
                href="#"
                className="text-sm text-indigo-900 font-semibold hover:text-indigo-700 transition-colors py-2"
              >
                FALE CONOSCO
              </a>
              
              {isLoggedIn && (
                <>
                  <div className="py-2">
                    <button
                      onClick={handleLogout}
                      disabled={isLoggingOut}
                      className="w-full text-left text-sm text-red-600 hover:text-red-700 font-medium disabled:opacity-50 py-2"
                    >
                      {isLoggingOut ? "Saindo..." : "Sair"}
                    </button>
                  </div>
                </>
              )}
            </div>
          </nav>
        )}
      </div>
    </header>
  );
}
